<template>
    <div class="jobs-form-container container">
        <div class="button-back">
            <button @click="$emit('back')" class="items-center flex">
                <img class="mr-3" src="/img/icons/arrow-left-white.svg" alt="">
                <p>{{$trans.get('jobs.back')}}</p>
            </button>
            <h3 class="w-full text-center ">{{$trans.get('jobs.apply')}} {{textselect()}}</h3>
        </div>
        <student-form v-if="select=='alumno'"></student-form>
        <business-form v-if="select=='empresa'"></business-form>
        <p v-if="select=='alumno'" class="text-form">{{$trans.get('jobs.text2')}}</p>
        <p v-if="select=='empresa'" class="text-form">{{$trans.get('jobs.text3')}}</p>
    </div>
</template>
<script>
import StudentForm from './StudentForm';
import BusinessForm from './BusinessForm';
export default {
    props:['select'],
    components:{
        StudentForm,
        BusinessForm
    },
    methods: {
        textselect(){

            switch (this.select) {
                case 'alumno':
                    return this.$trans.get('jobs.alumno');
                case 'empresa':
                    return this.$trans.get('jobs.business');

                default:
                    break;
            }
        }
    },
}
</script>
<style lang="scss">
    .jobs-form-container{
        padding: 2rem 1rem;
        @media (min-width:1024px) {
            padding: 4rem 1rem;
        }

        .text-form{
            max-width: 800px;
            margin: auto;
            margin-top: 3rem;
        }

        .button-back{
            display: flex;
            flex-direction: column;
            position: relative;
                button{
                    margin-bottom: 1rem;
                }
            @media (min-width:1024px) {
                button{
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin-bottom: 0;
                }

            }
        }
        .grid-form-jobs{
            display: flex;
            flex-direction: column;
            padding-top: 3rem;
            @media (min-width:1024px) {
                display: grid;
                grid-template-columns: 1fr 1fr;
                max-width: 800px;
                margin-left: auto;
                margin-right: auto;
            }
            .form-left,.form-right{
                max-width: 400px;
                width: 100%;
            }
            .form-left{
                @media (min-width:1024px) {
                    padding-right: 2rem;
                }
            }
            .form-right{
                @media (min-width:1024px) {
                    padding-left: 2rem;
                }
            }
        }
    }
</style>
